<template>
  <div>
    <br />

    <vue-data-table
      :headers="headers"
      :data="repairs"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
      :tableActions="tableActions"
      :filterFields="filterFields"
      :filterData="filter"
      filterTitle="Filtrer les réparations"
      @filter="toFilter"
      @reset="resetFilter"
      v-model:selected="selections"
    >
      <template #cell-amountPaid="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.amountPaid > 0 && row.amountPaid == row.totalPriceTTC
              ? 'bg-light-success text-success'
              : row.amountPaid > 0 && row.amountPaid < row.totalPriceTTC
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.amountPaid > 0 ? row.amountPaid : 'Impayé' }}
        </span>
      </template>

      <template #cell-validated="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="row.validated ? 'bg-light-success text-success' : 'bg-light-warning text-warning'"
        >
          {{ row.validated ? $t('sale22') : $t('sale23') }}
        </span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      filter: {
        customer_reference: null,
        startDate: new Date(
          new Date().setFullYear(new Date().getFullYear())
        )
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: new Date(
          new Date().setFullYear(new Date().getFullYear())
        )
          .toLocaleString("en-CA")
          .split(",")[0],
        status: "--",
      },
      selections: [],
      headers: [
        { field: "reference", label: "Référence", class: "" },
        { field: "customerFullName", label: "Client", class: "" },
        { field: "vehicleRegistrationPlate", label: "Immatriculation", class: "" },
        { field: "vehicleManufacturerName", label: "Fabricant", class: "" },
        { field: "vehicleModelName", label: "Modèle", class: "" },
        { field: "date", label: "Date", class: "" },
        { field: "totalPriceTTC", label: "Total TTC", class: "text-primary" },
        { field: "totalQuantity", label: "Quantité Totale", class: "" },
        { field: "amountPaid", label: "Montant payé", class: "text-success" },
        { field: "amountUnpaid", label: "Montant impayé", class: "text-danger" },
        { field: "userName", label: "Utilisateur", class: "" },
        { field: "validated", label: "État", class: "" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-info-square",
          class: "btn btn-primary",
          action: (repair) => {
            this.$router.push({
              name: "repairs-details",
              params: { reference: repair.reference },
            });
          },
        },
        {
          label: "Imprimer facture",
          icon: "bi bi-printer",
          class: "btn btn-secondary",
          action: (repair) => {
            this.print(repair.reference);
          },
        },
        {
          label: "Ordre de réparation",
          icon: "bi bi-file-earmark-text",
          class: "btn btn-outline-secondary",
          action: (repair) => {
            this.printOrder(repair.reference);
          },
        },
      ],
      summableColumns: [
        { field: "totalPriceTTC", class: "text-primary" },
        { field: "totalQuantity", class: "" },
        { field: "amountPaid", class: "text-success" },
        { field: "amountUnpaid", class: "text-danger" },
      ],
      tableActions: [
        {
          title: this.$t("sale12"),
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => this.refresh(),
        },
        {
          title: "Imprimer les factures sélectionnées",
          icon: "bi bi-printer",
          class: "btn btn-secondary",
          action: () => this.printMany(this.selections),
        },
        {
          title: "Nouvelle réparation",
          icon: "bi bi-plus-square",
          class: "btn btn-primary",
          action: () => this.$router.push({ name: "repairs-create" }),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("repair", {
      repairs: "getAll",
      totalQuantity: "getRepairsTotalQuantity",
      totalPriceTTC: "getRepairsTotalPriceTTC",
      totalPaid: "getRepairsTotalPaid",
      totalUnpaid: "getRepairsTotalUnpaid",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    filterFields() {
      return [
        {
          type: "select",
          label: "Client",
          model: "customer_reference",
          options: this.customers || [],
          labelColumn: "fullName",
          valueColumn: "reference",
        },
        {
          type: "date",
          label: "Du",
          model: "startDate",
        },
        {
          type: "date",
          label: "Au",
          model: "endDate",
        },
        {
          type: "dropdown",
          label: "Statut",
          model: "status",
          options: [
            { label: "--", value: "--" },
            { label: "En cours", value: "in_progress" },
            { label: "Finit", value: "ends" },
          ],
        },
      ];
    },
  },
  created() {
    this.$store.dispatch("customer/getAll");
    this.$store.dispatch("repair/fetchRepairs");
  },
  methods: {
    async search(value) {
      return await this.$store.commit("repair/search", value);
    },
    async refresh() {
      await this.$store.dispatch("repair/fetchRepairs");
      await this.$store.dispatch("customer/getAll");
    },
    async toFilter(data) {
      await this.$store.dispatch("repair/filter", data);
    },
    async resetFilter() {
      this.filter = {
        customer_reference: null,
        startDate: null,
        endDate: null,
        status: "--",
      };
      await this.$store.dispatch("repair/fetchRepairs");
    },
    async print(reference) {
      await this.$store.dispatch("repair/print", reference);
    },
    async printOrder(reference) {
      await this.$store.dispatch("repair/printRepairOrder", reference);
    },
    async printMany(data) {
      if (!data || data.length === 0) {
        return;
      }
      await this.$store.dispatch("repair/printManyBill", data);
    },
  },
  filters: {
    toFixedWithSpace: (value) => {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
  },
};
</script>
